import React, { Component } from 'react';
import { array, func, number, string } from 'prop-types';
import MidpointAdjustmentSetting from './MidpointAdjustmentSetting';
import ProposedRangeSetting from './ProposedRangeSetting';
import { MARKET_RANGE_TYPE } from '../../Utils/constants';

class MidPointSetting extends Component {
  static propTypes = {
    adjustCurrentMidpointClick: func,
    handleMidpointAdjustmentValueUpdate: func,
    midpointAdjustment: number,
    proposedRangeSelect: func,
    proposedRangeSetting: string,
    rangeType: string,
    setProposedRangeOptions: array
  };

  render() {
    const {
      adjustCurrentMidpointClick,
      handleMidpointAdjustmentValueUpdate,
      midpointAdjustment,
      proposedRangeSelect,
      proposedRangeSetting,
      rangeType,
      setProposedRangeOptions
    } = this.props;

    return (
      <div className="stat__group">
        {rangeType === MARKET_RANGE_TYPE ? (
          <ProposedRangeSetting
            className="statGroup-content midpoint-setting-content"
            handleProposedRangeSelect={proposedRangeSelect}
            proposedRangeSetting={proposedRangeSetting}
            rangeOptions={setProposedRangeOptions}
          />
        ) : (
          <MidpointAdjustmentSetting
            handleMidpointAdjustmentClick={adjustCurrentMidpointClick}
            handleMidpointAdjustmentValueUpdate={handleMidpointAdjustmentValueUpdate}
            midpointAdjustment={midpointAdjustment}
          />
        )}
      </div>
    );
  }
}

export default MidPointSetting;
